import {OnlinePaymentStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';


export function onlinePaymentStatusNameFilter(type: OnlinePaymentStatusEnum) {
  switch (type) {
    case OnlinePaymentStatusEnum.Waiting: return i18n.t(LF.Waiting) as string;
    case OnlinePaymentStatusEnum.Approved: return i18n.t(LF.Approved) as string;
  }
}
